import { render, staticRenderFns } from "./SchoolDetails.vue?vue&type=template&id=4f062ed2&"
import script from "./SchoolDetails.vue?vue&type=script&lang=js&"
export * from "./SchoolDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports